module.exports = __webpack_public_path__ + "img/49-image-1-1@2x.7fc677cb.png";